<div class="payments-panel flex flex-col gap-4">
  <div class="flex flex-row flex-wrap gap-2">
    <div class="flex-1">
      <h1 class="txp-h1">Project payments</h1>
    </div>
  </div>

  <form class="flex flex-col flex-1 gap-2" [formGroup]="form">
    <div class="grid grid-cols-1 gt-sm:grid-cols-4 grid-rows-1 gap-2 justify-stretch" formGroupName="filter">
      <mat-form-field>
        <mat-label>Search</mat-label>
        <input matInput formControlName="search" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Payment type</mat-label>
        <mat-select formControlName="paymentTypes" multiple>
          @for (paymentType of paymentTypes; track paymentType) {
            <mat-option [value]="paymentType">
              {{ paymentType | paymentMethod }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <app-payment-status-form class="flex-1 col-span-1 gt-sm:col-span-2" [parentForm]="queryForm" />
    </div>
    <app-payment-date-form class="flex-1" [parentForm]="queryForm" />
  </form>

  <mat-card>
    <mat-card-content>
      <div class="flex flex-col gap-4">
        @if (showLoader) {
          <div class="flex flex-1 justify-center content-center items-center">
            <app-spinner size="lg" />
          </div>
        } @else {
          <div class="flex flex-col gap-4">
            <div>
              <div class="overflow-x-auto">
                <table
                  mat-table
                  matSort
                  matSortActive="dateOfEngagement"
                  matSortDirection="asc"
                  matSortStart="asc"
                  [dataSource]="dataSource"
                >
                  <ng-container matColumnDef="Select">
                    <th *matHeaderCellDef mat-header-cell>
                      <mat-checkbox
                        [checked]="engagementsSelection.hasValue() && isAllSelected()"
                        [indeterminate]="engagementsSelection.hasValue() && !isAllSelected()"
                        [aria-label]="checkboxLabel()"
                        (change)="$event ? masterToggle() : null"
                      >
                      </mat-checkbox>
                    </th>
                    <td *matCellDef="let element" mat-cell>
                      <mat-checkbox
                        [checked]="engagementsSelection.isSelected(element)"
                        [aria-label]="checkboxLabel(element)"
                        (click)="$event.stopPropagation()"
                        (change)="$event ? engagementsSelection.toggle(element) : null"
                      >
                      </mat-checkbox>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="expertName">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Expert</th>
                    <td *matCellDef="let element" mat-cell>
                      <a
                        class="expert-name"
                        [routerLink]="['/admin/experts', element.expertId]"
                        [queryParams]="{ tab: 'Engagements' }"
                      >
                        {{ element.expertName }}
                      </a>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="email">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Email</th>
                    <td *matCellDef="let element" mat-cell>
                      <span [matTooltip]="element.email">
                        {{ element.email }}
                      </span>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="engagementTitle">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Engagement</th>
                    <td *matCellDef="let element" mat-cell>
                      <span class="nowrap-title">
                        {{ element.engagementTitle }}
                      </span>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="owner">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Owner</th>
                    <td *matCellDef="let element" mat-cell>
                      {{ element.owner }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="amountOwed">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Amount owed</th>
                    <td *matCellDef="let element" mat-cell>
                      {{ element.amountOwed }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="currency">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Currency (paid in)</th>
                    <td *matCellDef="let element" mat-cell>
                      {{ element.currency }} ({{ element.actualPaymentCurrency }})
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="paymentType">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Payment type</th>
                    <td *matCellDef="let element" mat-cell>
                      {{ element.paymentType | paymentMethod }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="unitsUsed">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header title="Units">Units (adjustment)</th>
                    <td *matCellDef="let element" mat-cell>
                      {{ element.unitsUsed }} ({{ element.unitsUsedAdjustment }})
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="dateOfEngagement">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header title="Date of engagement">DOE</th>
                    <td *matCellDef="let element" mat-cell>
                      {{ element.dateOfEngagement ? (element.dateOfEngagement | date: 'shortDate') : '' }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="paymentStatus">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Status</th>
                    <td *matCellDef="let element" mat-cell>
                      @if (disablePaymentActions) {
                        {{ element.paymentStatus | paymentStatus }}
                      } @else {
                        <mat-form-field class="payment-status py-1">
                          <mat-select
                            [(ngModel)]="element.paymentStatus"
                            (ngModelChange)="updateEngagementPaymentStatus(element.engagementId, $event)"
                          >
                            @for (status of paymentStatuses; track status) {
                              <mat-option [value]="status">
                                {{ status | paymentStatus }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      }
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="Edit">
                    <th *matHeaderCellDef mat-header-cell></th>
                    <td *matCellDef="let element" mat-cell>
                      <span
                        class="material-icons action cursor-pointer"
                        matTooltip="Open engagement notes"
                        (click)="openNotesDialog(element)"
                      >
                        sticky_note_2
                      </span>
                    </td>
                  </ng-container>

                  <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
                  <tr
                    *matRowDef="let row; columns: displayedColumns"
                    mat-row
                    [class.inactive]="!row.paymentActive"
                  ></tr>

                  <tr *matNoDataRow class="mat-row">
                    <td
                      class="mat-cell"
                      data-test-id="payments-table-no-payments-message"
                      [attr.colspan]="displayedColumns.length"
                    >
                      <app-empty-state title="No payments" />
                    </td>
                  </tr>
                </table>
              </div>

              <mat-paginator
                showFirstLastButtons
                [pageSize]="10"
                [pageSizeOptions]="[5, 10, 20, 50, 100]"
              ></mat-paginator>
            </div>
          </div>
        }
        <app-payment-actions
          class="self-end"
          [type]="PaymentRecordType.Engagement"
          [engagements]="engagementsSelection.selected"
          [loading]="showLoader"
          [disableMarkAsSent]="disablePaymentActions"
          (statusUpdates)="receiveStatusUpdates($event)"
        />
      </div>
    </mat-card-content>
  </mat-card>
</div>
